export const getFullImageUrl = image => {
    return image ? `${process.env.VUE_APP_LOCAL_HOST}event/images/${image}` : ''
}